import React, { useState } from "react";
import Parse from "parse";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setParcelsForStagesInStore } from "../../actions/parcels";
import { updateToastInfo } from "../../actions/settings";
import { updateSpinnerState } from "../../actions/spinner";
import ParcelStatusPage from "../../components/common/parcelStatusPages";
import { getParcelsByStatusAndSubStatus, updateParcelDataWithInfo } from "../../parse-functions/parcels";
import { Routes } from "../../router/routes";
import { convertArrayToObj } from "../../utils/json";
import { setFiltersInStore } from "../../actions/filters";
import { returnEndOfDay, returnStartOfDay } from "../../utils/datetime";
import { defectivePickupReceivedTableColumns } from "./utils";

const PickupReceivedList = () => {
    const pageStatus = "replacementpicked";
    const { t } = useTranslation();

    const breadCrumbItems = [{
        title: t("Defective - Received"),
        link: Routes.Defective.PickupReceived.path
    }];
    const dispatch = useDispatch();

    const [selectedParcelId, setSelectedParcelId] = useState(null);
    const storeCode = useSelector((state) => state?.user?.warehouse?.warehouseCode || "");
    const filtersValue = useSelector((state) => state.filters?.[pageStatus]);
    const parcels = useSelector((state) => state?.parcels?.[pageStatus] || {});
    const zone = useSelector((state) => state?.user?.warehouse?.zone || "");
    
    const handleFiltersSubmit = (startDate, endDate) => {
        dispatch(setFiltersInStore({
            pageType: pageStatus,
            data: {
              startDate: new Date(startDate),
              endDate: new Date(endDate)
            }
          }))
        getAvailableParcels(startDate, endDate);
    };

    const getAvailableParcels = async (startDate, endDate) => {
        dispatch(updateSpinnerState(true));
        try {
            const filters = {
                subStatus: ["replacementpicked", "defectivepicked"],
                storeCode,
                startDate: new Date(startDate),
                endDate: new Date(endDate),
                zone
            };
            const parcels = await getParcelsByStatusAndSubStatus(filters);
            dispatch(setParcelsForStagesInStore(pageStatus, convertArrayToObj(JSON.parse(JSON.stringify(parcels)), "objectId")))
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'success',
                title: t('Orders fetched'),
                message: t("You can schedule your parcels here for which replacement is pending")
            }))

        } catch (e) {
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Error'),
                message: t(e.message)
            }))
        }
    }
    const onRowSelect = (value, objectId) => {
        if (selectedParcelId) {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Only 1 item allowed'),
                message: t("Please deselect other item before choosing this")
            }))
        } else {
            if (value) {
                setSelectedParcelId(objectId);
            } else {
                setSelectedParcelId(null);
            }
        }
    }
    const onRefreshClick = () => {
        const currentStartDate = filtersValue.startDate ? new Date(filtersValue.startDate): returnStartOfDay(new Date());
        const currentEndDate = filtersValue.endDate ? new Date(filtersValue.endDate) : returnEndOfDay(new Date());
        getAvailableParcels(currentStartDate, currentEndDate)
    }

    const onRescheduleConfirm = async () => {
        dispatch(updateSpinnerState(true));
        try {
            const formData = {
                data: {
                    receivedAt: new Date(),
                    receivedBy: Parse.User.current().getUsername()
                },
                objectId: selectedParcelId
            }
            await updateParcelDataWithInfo(formData);
            dispatch(updateToastInfo({
                show: true,
                type: 'success',
                title: t('Replacement Item Received'),
                message: t("This parcel's Replacement item has been marked as received Successfully")
            }))
            dispatch(updateSpinnerState(false));

        } catch (e) {
            dispatch(updateSpinnerState(false));
        }
    };
    const handleItemBulkUpdate = (actionId) => {
        if (selectedParcelId) {
            switch (actionId) {
                case "receive": {
                    onRescheduleConfirm()
                    break;
                }
                default: {
                    dispatch(updateToastInfo({
                        show: true,
                        type: 'danger',
                        title: t('Select an Action'),
                        message: t("Please select an action from the dropdown")
                    }))
                    break;
                }
            }
        } else {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Select Item'),
                message: t("Please select an item to take action")
            }))
        }
    }
    return (
        <>
            <ParcelStatusPage
                pageType={pageStatus}
                filtersValue={filtersValue}
                filterSubmit={handleFiltersSubmit}
                tableData={parcels}
                tableColumns={defectivePickupReceivedTableColumns(onRowSelect)}
                handleRefresh={onRefreshClick}
                pageTitle={t("Defective Received")}
                breadCrumbItems={breadCrumbItems}
                pageSubTitle={t("All the parcels for which the defective has been received")}
                searchPlaceHolder={t("Search by Invoice No. in Database")}
                handleItemBulkUpdate={handleItemBulkUpdate}
                bulkActionOptions={[{
                    label: "Receive",
                    value: "receive"
                }]}
                enableBulkActions={selectedParcelId && Object.keys(parcels)?.length > 0}
            />
        </>
    )
}
export default PickupReceivedList;